import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c32c7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "col-form-label fw-bold mb-2" }
const _hoisted_3 = { class: "d-lg-flex" }
const _hoisted_4 = { class: "mx-lg-4" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  colspan: "11",
  class: "text-center fw-bold"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  colspan: "11",
  class: "text-center fw-bold"
}
const _hoisted_10 = { class: "text-init w_200" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "w_100" }
const _hoisted_13 = {
  key: 0,
  class: "w_110"
}
const _hoisted_14 = {
  key: 1,
  class: "w_110"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 2,
  class: "w_110"
}
const _hoisted_17 = {
  key: 3,
  class: "w_110"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 4,
  class: "w_110"
}
const _hoisted_20 = {
  key: 5,
  class: "w_110"
}
const _hoisted_21 = {
  key: 6,
  class: "w_110"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "w_200" }
const _hoisted_24 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_25 = { class: "mx-1" }
const _hoisted_26 = { class: "w_150" }
const _hoisted_27 = { class: "not-seperate-text" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen color-edit" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "d-lg-flex" }
const _hoisted_32 = { class: "mx-lg-4" }

import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import Search from '@/views/community-admin/post-management/components/Search.vue'
import ModalEdit from '@/views/community-admin/post-management/components/ModalEdit.vue'
// import Button from '@/components/button/index.vue'
import { ReplayName, numberWithCommas, MODAL_ID } from '@/constants/common'
import { computed, ComputedRef, ref, watch, onMounted, reactive } from 'vue'
// import CellSort from '@/components/cell-sort/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import Table from '@/components/table/index.vue'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'

import { translate } from '@/languages/i18n'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { ACCOUNT_STORE, COMMUNITY_STORE, POST_STORE, USER_POST_STORE } from '@/store/constants'
import { GetPostType } from '@/store/modules/user-post/user-post.getters'
import dayjs from 'dayjs'
import ModalCreateSuccess from '@/views/community-admin/post-management/components/ModalCreateSuccess.vue'
import ModalEditSuccess from '@/views/community-admin/post-management/components/ModalEditSuccess.vue'
import LikeModal from '@/views/community-admin/post-management/components/LikeModal.vue'
import InterestModal from '@/views/community-admin/post-management/components/InterestModal.vue'
import PostModal from '@/views/community-admin/post-management/components/ModalPost.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Loading from '@/components/loading/index.vue'

import ModalUpdateStatusChat from '@/views/community-admin/post-management/components/ModalUpdateStatus.vue'
import ModalUpdatePrivateSuccess from '@/views/community-admin/groups/components/ModalUpdatePrivateSuccess.vue'
import ModalUpdatePublicSuccess from '@/views/community-admin/groups/components/ModalUpdatePublicSuccess.vue'
import DeleteCommentModal from '@/views/shared/communities/components/DeleteCommentModal.vue'
import DeleteCommentSuccessModal from '@/views/shared/communities/components/DeleteCommentSuccessModal.vue'
import UpdateCommentErrorModal from '@/views/shared/communities/components/UpdateCommentErrorModal.vue'
import ModalConfirmStatusComment from '@/views/community-admin/post-management/components/ModalConfirmStatusComment.vue'
import ModalUpdateStatusCommentResult from '@/views/community-admin/post-management/components/ModalUpdateStatusCommentResult.vue'

import { pick } from 'lodash'
import TotalRecords from '@/components/total-records/index.vue'
import { Modal } from 'bootstrap'
import InterestConfirmModal from '@/views/shared/communities/components/InterestConfirmModal.vue'
import MessageModal from '@/views/shared/communities/components/MessageModal.vue'
import { PostType } from '@/store/modules/post'
import { changeModalElevation, isSaasTypePool } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentData = ref({})
const route = useRoute()
const router = useRouter()
const store = useStore()
const count = ref<number>(0)
//2022/11/12 TienNV Fix for UAT#5121: CT10 (Ph2-R20221116)
const postDetail = computed(() => store.getters[USER_POST_STORE.GETTERS.GET_POST_DETAIL])
const modalEdit = ref()
const modalViewPost = ref()
const modalDeleteComment = ref()
const modalDeleteCommentSuccess = ref()
const modalDeleteCommentError = ref()
const commentIsDelete = ref(true)
const listUserMention = computed(() => store.getters[POST_STORE.GETTERS.LIST_USER_MENTION_POST])
const listUser = computed<ComputedRef>(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])
const interestConfirmModal = ref()
const postModal = ref()
const modalConfirmStatusComment = ref()
const resultUpdateStatusComment = reactive({
  success: true,
  commentPublished: true,
})
const modalUpdateStatusCommentResult = ref()

const storeSaasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])

const convertContentType = (content_type: number): string => {
  const contentTypeObj = {
    1: '記事',
    2: '募集',
    3: '求人',
    4: '自動投稿',
  }

  return contentTypeObj[content_type]
}

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('postManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('userPost2'),
    to: '',
    active: true,
  },
]

const deleteTargetPostId = ref<string>()
const deleteTargetPostCommentId = ref<string>()
const deleteTargetCommentPublished = ref<boolean>()

const checkSearchData = computed((): boolean => Object.keys(pick(route.query, 'title', 'content', 'user_name')).length > 0 && postData.value?.posts?.length === 0)

const getInterest = (id: string): void => {
  store.dispatch(POST_STORE.ACTIONS.GET_INTEREST, { id: id, params: { create_by_admin: true } })
}

const getLike = (id: string): void => {
  store.dispatch(POST_STORE.ACTIONS.GET_LIKES, { id: id, params: { create_by_admin: true } })
}

const getListUser = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)
}
const getUserMention = async (postId) => {
  if (storeSaasType.value && !isSaasTypePool(storeSaasType.value)) {
    await store.dispatch(POST_STORE.ACTIONS.GET_USER_MENTION_POST, { post_id: postId, create_by_admin: true })
  }
}

//2022/11/12 TienNV Fix for UAT#5121: CT10 (Ph2-R20221116)
const setCurrentData = async (postId: string, type): void => {
  await getUserMention(postId)
  await store.dispatch(USER_POST_STORE.ACTIONS.SET_POST_DETAIL, {
    screen: 'userPost',
    community_id: route.params.id,
    postId,
    params: {
      target_content_id: route.query?.target_content_id,
    },
  })
  currentData.value = postDetail.value.post
  //2022/11/14 TienNV Fix for UAT#5121: CT10 (Ph2-R20221116)
  if (currentData.value) {
    currentData.value.create_by_admin = true
  }

  store.dispatch(USER_POST_STORE.ACTIONS.SET_SHOW_ALL_COMMENTS, false)
  count.value++
  if (type === 'viewEdit' && postDetail.value !== 'error') modalEdit.value.show()
  else if (type === 'viewPost' && postDetail.value !== 'error') modalViewPost.value.show()
}

const showDeleteCommentModal = () => {
  modalDeleteComment.value.show()
}

const showDeleteCommentSuccessModal = (isDelete) => {
  commentIsDelete.value = isDelete
  modalDeleteCommentSuccess.value.show()
}
const showUpdateCommentErrorModal = () => {
  // modalDeleteCommentError.value.show()
}
const showUpdateStatusCommentModal = () => {
  modalConfirmStatusComment.value.show()
}
const afterUpdateStatusComment = (resultObject) => {
  resultUpdateStatusComment.success = resultObject.resultUpdate
  resultUpdateStatusComment.commentPublished = resultObject.commentPublished
  modalConfirmStatusComment.value.hide()
  setTimeout(() => {
    modalUpdateStatusCommentResult.value.show()
  }, 400)
}

const postData = computed<ComputedRef<GetPostType>>(() => store.getters[USER_POST_STORE.GETTERS.GET_POST])
const path = ref(route.path)

onMounted(() => {
  // 2022/09/12 CW-Phuong Fix for horizontal fixing#7: OF10
  router.push({ path: route.path, query: { ...route.query } })
  const modalInterest = document.querySelector('#interest')
  const modalPost = document.querySelector('#modalPost')
  const modalLike = document.querySelector('#like')

  modalInterest.addEventListener('hidden.bs.modal', function () {
    hiddenModal()
  })
  modalPost.addEventListener('hidden.bs.modal', function () {
    hiddenModal()
    if (route.query.target_content_id) {
      const { target_content_id, ...remainingQueries } = route.query

      router.replace({
        path: route.path,
        query: remainingQueries,
      })
    }
  })
  modalLike.addEventListener('hidden.bs.modal', function () {
    hiddenModal()
  })

  const elementDeleteCommentModal = document.getElementById('deleteComment')
  const elementDeleteCommentSuccessModal = document.getElementById('deleteCommentSuccess')
  const elementConfirmStatusComment = document.getElementById('modalConfirmStatusComment')
  const elementConfirmStatusCommentResult = document.getElementById('modalUpdateStatusCommentResult')
  elementDeleteCommentModal?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementDeleteCommentSuccessModal?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementDeleteCommentModal?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)
  elementDeleteCommentSuccessModal?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)
  elementConfirmStatusComment?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementConfirmStatusComment?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)
  elementConfirmStatusCommentResult?.addEventListener('show.bs.modal', displayBackdropInFrontOfPost)
  elementConfirmStatusCommentResult?.addEventListener('hidden.bs.modal', displayBackdropInBackOfPost)

  //2022/11/12 TienNV Fix for UAT#5121: CT10 (Ph2-R20221116)
  modalEdit.value = new Modal(document.getElementById('modalEdit'))
  modalViewPost.value = new Modal(document.getElementById('modalPost'))
  modalDeleteComment.value = new Modal(elementDeleteCommentModal)
  modalDeleteCommentSuccess.value = new Modal(elementDeleteCommentSuccessModal)
  modalDeleteCommentError.value = new Modal(document.getElementById('updateCommentError'))
  modalConfirmStatusComment.value = new Modal(elementConfirmStatusComment)
  modalUpdateStatusCommentResult.value = new Modal(elementConfirmStatusCommentResult)
})

const hiddenModal = () => {
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  while (modalBackdrop.length > 0) {
    modalBackdrop[0].parentNode.removeChild(modalBackdrop[0])
  }
}

// モーダルを重ねて表示する際に、backdropを最前面のモーダルの後ろに配置する
const displayBackdropInFrontOfPost = () => {
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  if (modalBackdrop.length > 0) {
    modalBackdrop[0].style.zIndex = 1599
  }
}

// モーダルを閉じる際に、前面に持ってきたbackdropを元の位置に戻す
const displayBackdropInBackOfPost = () => {
  const modalBackdrop = document.getElementsByClassName('modal-backdrop')
  for (const backdrop of modalBackdrop) {
    backdrop.style.zIndex = 1050
  }
}

const setCommentData = (post_id, id, published) => {
  deleteTargetPostId.value = post_id
  deleteTargetPostCommentId.value = id
  deleteTargetCommentPublished.value = published
}

onMounted(() => {
  if (route.params?.id) {
    const params = { ...route.query, page_of_number: route.query?.page_of_number || 30 }
    const sortFields = ['post_content_type', 'total_likes', 'total_comments', 'total_interests', 'management_no', 'customer_name', 'created_at']
    const checkSort = sortFields.filter((field) => !!route.query[field]).length > 0
    if (!checkSort) {
      params['created_at'] = 'desc'
    }
    store.dispatch(USER_POST_STORE.ACTIONS.GET_POST, {
      chatroom_id: route.params.id,
      params,
    })

    getListUser()
  }
  // Show modal detail if exists query post_id
  if (route.query?.post_id) {
    setCurrentData(route.query?.post_id.toString(), 'viewPost')
  }
})

watch(
  () => route,
  (oldPath) => {
    if (route.params?.id && oldPath.path === path.value) {
      const params = { ...route.query, page_of_number: route.query?.page_of_number || 30 }
      const sortFields = ['post_content_type', 'total_likes', 'total_comments', 'total_interests', 'management_no', 'customer_name', 'created_at']
      const checkSort = sortFields.filter((field) => !!route.query[field]).length > 0
      if (!checkSort) {
        params['created_at'] = 'desc'
      }
      store.dispatch(USER_POST_STORE.ACTIONS.GET_POST, {
        chatroom_id: route.params.id,
        params,
      })
    }
  },
  {
    // immediate: true,
    deep: true,
  }
)

const handleInterestConfirm = async (post) => {
  postModal.value?.handleLikeOrInterest('interest', post.id)
}

const handlePostInterestClick = () => {
  changeModalElevation('modalPost', 'backdrop')
  interestConfirmModal.value.showDialog({ id: (currentData.value as PostType)?.id })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: breadcrumb,
      class: "mx-0"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('userPost2')), 1),
      _createVNode(Search, { userPost: true }),
      _createVNode(TotalRecords, {
        totalRecords: _unref(postData)?.total_records
      }, null, 8, ["totalRecords"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Pagination, {
          totalPage: _unref(postData).total_pages,
          totalDataOfPage: _unref(postData)?.posts?.length
        }, null, 8, ["totalPage", "totalDataOfPage"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Table, {
          columns: [
          { field: 'postTitleSearch', name: _unref(translate)('title') },
          { field: 'post_content_type', name: _unref(translate)('postType'), sort: _ctx.sortField === 'post_content_type' },
          { field: 'total_likes', name: _unref(translate)('like'), sort: _ctx.sortField === 'total_likes' },
          { field: 'total_comments', name: _unref(translate)('comment'), sort: _ctx.sortField === 'total_comments' },
          { field: 'total_interests', name: _unref(translate)('interest'), sort: _ctx.sortField === 'total_interests' },
          { field: 'management_no', name: _unref(translate)('managementNo'), sort: _ctx.sortField === 'management_no' },
          { field: 'customer_name', name: _unref(translate)('creator'), sort: _ctx.sortField === 'customer_name' },
          { field: 'created_at', name: _unref(translate)('dateSubmissionUserPost'), sort: _ctx.sortField === 'created_at' },
          { field: 'edit', name: _unref(translate)('edit') },
        ],
          sortCells: ['post_content_type', 'total_likes', 'total_comments', 'total_interests', 'management_no', 'customer_name', 'created_at']
        }, {
          default: _withCtx(() => [
            (_unref(checkSearchData))
              ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(translate)('OE65searchNoData')), 1)
                ]))
              : (_unref(postData)?.posts?.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(translate)('OE65noData')), 1)
                  ]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postData).posts, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass(["align-middle text-center", { rowEven: index % 2 === 0, rowExaminated: item.published === false }]),
                key: index
              }, [
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("u", {
                    onClick: ($event: any) => (setCurrentData(item.id, 'viewPost')),
                    class: "cursor-pointer"
                  }, _toDisplayString(item.title), 9, _hoisted_11)
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(convertContentType(item.content_type)), 1),
                (item.like_count === 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(item.like_count), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_14, [
                      _createElementVNode("u", {
                        class: "cursor-pointer",
                        onClick: ($event: any) => (getLike(item.id)),
                        "data-bs-Toggle": "modal",
                        "data-bs-target": "#like"
                      }, _toDisplayString(_unref(numberWithCommas)(item.like_count)), 9, _hoisted_15)
                    ])),
                (item.comment_count === 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(item.comment_count), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_17, [
                      _createElementVNode("u", {
                        class: "cursor-pointer",
                        onClick: ($event: any) => (setCurrentData(item.id, 'viewPost'))
                      }, _toDisplayString(_unref(numberWithCommas)(item.comment_count)), 9, _hoisted_18)
                    ])),
                (item.content_type === 1)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString('-')))
                  : (item.content_type !== 1 && item.interest_count === 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(item.interest_count), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_21, [
                        _createElementVNode("u", {
                          class: "cursor-pointer",
                          "data-bs-Toggle": "modal",
                          "data-bs-target": "#interest",
                          onClick: ($event: any) => (getInterest(item.id))
                        }, _toDisplayString(_unref(numberWithCommas)(item.interest_count)), 9, _hoisted_22)
                      ])),
                _createElementVNode("td", null, _toDisplayString(item.management_no), 1),
                _createElementVNode("td", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(UserAliasIcon, {
                      userType: item?.user_type
                    }, null, 8, ["userType"]),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(ReplayName)(item?.is_deleted_in_30_days, item?.available, item?.family_name, item?.given_name, item?.user_type)) + " " + _toDisplayString(item?.user_type === 'alumni' && [0, 1].includes(item?.is_deleted_in_30_days) ? `（ ${item?.display_name} ）` : ''), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(item.created_at ? _unref(dayjs)(item.created_at).format('YYYY/MM/DD HH:mm:ss') : ''), 1)
                ]),
                _createElementVNode("td", {
                  class: _normalizeClass([['cursor-pointer'], "w_100"]),
                  onClick: ($event: any) => (setCurrentData(item.id, 'viewEdit'))
                }, _hoisted_30, 8, _hoisted_28)
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["columns"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(Pagination, {
          totalPage: _unref(postData).total_pages,
          totalDataOfPage: _unref(postData)?.posts?.length
        }, null, 8, ["totalPage", "totalDataOfPage"]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(SelectCustom, {
            options: dataSelectRecordPerPage.value,
            keyName: 'page_of_number'
          }, null, 8, ["options"])
        ])
      ])
    ]),
    _createVNode(Loading, {
      loading: _unref(postData).loading
    }, null, 8, ["loading"]),
    _createVNode(ModalEdit, {
      post: currentData.value,
      userPost: true,
      count: count.value,
      modalEdit: modalEdit.value
    }, null, 8, ["post", "count", "modalEdit"]),
    _createVNode(ModalEditSuccess),
    _createVNode(ModalCreateSuccess),
    _createVNode(InterestModal),
    _createVNode(LikeModal),
    _createVNode(PostModal, {
      ref: (_value, _refs) => {
        _refs['postModal'] = _value
        postModal.value = _value
      },
      onSetCommentData: setCommentData,
      onShowDeleteCommentModal: showDeleteCommentModal,
      onShowUpdateCommentErrorModal: showUpdateCommentErrorModal,
      onShowUpdateStatusCommentModal: showUpdateStatusCommentModal,
      postId: currentData.value?.id,
      userPost: true,
      "on-interest-click": handlePostInterestClick,
      listUser: _unref(listUser),
      listUserMention: _unref(listUserMention)
    }, null, 8, ["postId", "listUser", "listUserMention"]),
    _createVNode(ModalUpdateStatusChat),
    _createVNode(ModalUpdatePrivateSuccess),
    _createVNode(ModalUpdatePublicSuccess),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser),
    _createVNode(DeleteCommentModal, {
      onShowDeleteCommentSuccessModal: showDeleteCommentSuccessModal,
      postId: deleteTargetPostId.value,
      postCommentId: deleteTargetPostCommentId.value,
      commentPublishedFlg: deleteTargetCommentPublished.value,
      create_by_admin: true
    }, null, 8, ["postId", "postCommentId", "commentPublishedFlg"]),
    _createVNode(DeleteCommentSuccessModal, { "is-delete": commentIsDelete.value }, null, 8, ["is-delete"]),
    _createVNode(UpdateCommentErrorModal),
    _createVNode(InterestConfirmModal, {
      ref: (_value, _refs) => {
        _refs['interestConfirmModal'] = _value
        interestConfirmModal.value = _value
      },
      "on-confirm": (p) => handleInterestConfirm(p)
    }, null, 8, ["on-confirm"]),
    _createVNode(MessageModal, {
      id: _unref(MODAL_ID).INTEREST_COMPLETE,
      header: _unref(translate)('OF10completeTitle'),
      contentMessage: _unref(translate)('OF10completeMessage1'),
      subContentMessage: _unref(translate)('OF10completeMessage2')
    }, null, 8, ["id", "header", "contentMessage", "subContentMessage"]),
    _createVNode(ModalConfirmStatusComment, { onAfterUpdateComment: afterUpdateStatusComment }),
    _createVNode(ModalUpdateStatusCommentResult, {
      "result-success": _unref(resultUpdateStatusComment).success,
      "comment-published": _unref(resultUpdateStatusComment).commentPublished
    }, null, 8, ["result-success", "comment-published"])
  ], 64))
}
}

})